<template>
    <div class="">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Login page</label>
            <input type="text" v-model="searchpage" class="form-control" placeholder="Type to select" />
          </div>
          <div class="page-list mt-4">
            <ul class="list-group">
              <li class="list-group-item" v-for="p in pages" :key="p.ID">
                <input type="radio" name="loginpage" :value="p.ID" v-model="auth.page_id">
                {{ p.method}} {{ p.page }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Login page [Get token]</label>
            <input type="text" class="form-control" v-model="searchSource" placeholder="Type to select" />
          </div>
          <div class="page-list mt-4">
            <ul class="list-group">
              <li class="list-group-item" v-for="p in source" :key="p.ID">
                <input type="radio" name="sourcepage" :value="p.ID" v-model="auth.source_page_id">
                {{ p.method}} {{ p.page }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card mt-4 mb-4">
        <div class="card-body">
          <h3>User settings</h3>
          <div class="form-group" v-for="(input, k) in auth.setting" :key="k">
              <div class="row">
                  <div class="col-md-6">
                      <label>Parameter</label>
                      <input type="text" class="form-control" v-model="auth.setting[k]['param']">
                  </div>
                  <div class="col-md-6">
                      <label>Value</label>
                      <input type="text" class="form-control" v-model="auth.setting[k]['value']">
                  </div>
              </div>
              <span>
                  <i class="fas fa-minus-circle text-danger" @click="remove(k)" v-show="k || ( !k && auth.setting.length > 1)">

                  </i>
                  <i class="fas fa-plus-circle text-success" @click="add(k)" v-show="k == auth.setting.length-1"></i>
              </span>
          </div>
        </div>
      </div>
      <div class="">
          <button type="submit" class="btn btn-info text-light" @click.prevent="createAuth">
          {{ title }}
          </button>
      </div>
    </div>
</template>
<script>
  export default {
    props: {
      auth_id: Number
    },
    components: {
    },
    data () {
      return {
        success: false,
        advance: false,
        host: [],
        title : 'Create',
        searchpage: "",
        searchSource: "",
        pages: [],
        source: [],
        auth: {
          page_id: 0,
          source_page_id: 0,
          setting: [{'param': '','value':''}]
        }
      }
    },
    mounted() {
      this.init();
    },
    watch: {
      searchpage: function(newVal) {
        this.pageSearch(newVal, 'page');
      },
      searchSource: function(newVal) {
        this.pageSearch(newVal, 'source');
      }
    },
    methods: {
      pageSearch(search, stype) {
        let me = this;
        this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + "/pages?s=" + search)
          .then(res => {
            var r = res.data;
            if (r.success) {
                if (stype == 'page') {
                  me.pages = r.data;
                } else {
                  me.source = r.data;
                }

            }
          });
      },
      add() {
          this.auth.setting.push({
              param: '',
              value: '',
          });
      },

      remove(index) {
          this.auth.setting.splice(index, 1);
      },
      init() {
          const me = this;
          this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + "/pages?s=")
          .then(res => {
            var r = res.data;
            if (r.success) {
                me.pages = r.data;
                me.source = r.data;
            }
          })

          if (this.auth_id != 0) {
            this.title = "Update Authentication";
            this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + '/auth/' + this.auth_id)
            .then(res => {
              var r = res.data;
              if (r.success) {
                me.auth = r.data[0];
                if (r.setting !== null) {
                  me.auth.setting = r.setting;
                } else {
                  me.auth.setting = [{'param':'', 'value':''}];
                }
              }
            });
          }

          this.$emit("callback", this.title);
      },

      createAuth() {
          const me = this;
          var method = 'post';
          var host = this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + '/auth';

          if (this.auth_id != 0) {
              method = 'put';
              host = this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + '/auth/' + this.auth_id;
          }

          this.$axios({ method, url: host, data: this.auth })
          .then(res => {
              var r = res.data;
              if (r.success) {
                  me.$swal({
                      title: r.message
                  });
              }
          });
        this.$emit("callback", true);
      }
    }
  }

</script>